function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;

var __export = function __export(target, all) {
  for (var name in all) {
    __defProp(target, name, {
      get: all[name],
      enumerable: true
    });
  }
};

var __copyProps = function __copyProps(to, from, except, desc) {
  if (from && typeof from === "object" || typeof from === "function") {
    var _iterator = _createForOfIteratorHelper(__getOwnPropNames(from)),
        _step;

    try {
      var _loop = function _loop() {
        var key = _step.value;
        if (!__hasOwnProp.call(to, key) && key !== except) __defProp(to, key, {
          get: function get() {
            return from[key];
          },
          enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable
        });
      };

      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        _loop();
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }

  return to;
};

var __toESM = function __toESM(mod, isNodeMode, target) {
  return target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps( // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", {
    value: mod,
    enumerable: true
  }) : target, mod);
};

var __toCommonJS = function __toCommonJS(mod) {
  return __copyProps(__defProp({}, "__esModule", {
    value: true
  }), mod);
};

var players_exports = {};

__export(players_exports, {
  default: function _default() {
    return players_default;
  }
});

module.exports = __toCommonJS(players_exports);

var import_utils = require("../utils");

var import_patterns = require("../patterns");

var players_default = [{
  key: "youtube",
  name: "YouTube",
  canPlay: import_patterns.canPlay.youtube,
  lazyPlayer: (0, import_utils.lazy)(function () {
    return import(
    /* webpackChunkName: 'reactPlayerYouTube' */
    "./YouTube");
  })
}, {
  key: "soundcloud",
  name: "SoundCloud",
  canPlay: import_patterns.canPlay.soundcloud,
  lazyPlayer: (0, import_utils.lazy)(function () {
    return import(
    /* webpackChunkName: 'reactPlayerSoundCloud' */
    "./SoundCloud");
  })
}, {
  key: "vimeo",
  name: "Vimeo",
  canPlay: import_patterns.canPlay.vimeo,
  lazyPlayer: (0, import_utils.lazy)(function () {
    return import(
    /* webpackChunkName: 'reactPlayerVimeo' */
    "./Vimeo");
  })
}, {
  key: "facebook",
  name: "Facebook",
  canPlay: import_patterns.canPlay.facebook,
  lazyPlayer: (0, import_utils.lazy)(function () {
    return import(
    /* webpackChunkName: 'reactPlayerFacebook' */
    "./Facebook");
  })
}, {
  key: "streamable",
  name: "Streamable",
  canPlay: import_patterns.canPlay.streamable,
  lazyPlayer: (0, import_utils.lazy)(function () {
    return import(
    /* webpackChunkName: 'reactPlayerStreamable' */
    "./Streamable");
  })
}, {
  key: "wistia",
  name: "Wistia",
  canPlay: import_patterns.canPlay.wistia,
  lazyPlayer: (0, import_utils.lazy)(function () {
    return import(
    /* webpackChunkName: 'reactPlayerWistia' */
    "./Wistia");
  })
}, {
  key: "twitch",
  name: "Twitch",
  canPlay: import_patterns.canPlay.twitch,
  lazyPlayer: (0, import_utils.lazy)(function () {
    return import(
    /* webpackChunkName: 'reactPlayerTwitch' */
    "./Twitch");
  })
}, {
  key: "dailymotion",
  name: "DailyMotion",
  canPlay: import_patterns.canPlay.dailymotion,
  lazyPlayer: (0, import_utils.lazy)(function () {
    return import(
    /* webpackChunkName: 'reactPlayerDailyMotion' */
    "./DailyMotion");
  })
}, {
  key: "mixcloud",
  name: "Mixcloud",
  canPlay: import_patterns.canPlay.mixcloud,
  lazyPlayer: (0, import_utils.lazy)(function () {
    return import(
    /* webpackChunkName: 'reactPlayerMixcloud' */
    "./Mixcloud");
  })
}, {
  key: "vidyard",
  name: "Vidyard",
  canPlay: import_patterns.canPlay.vidyard,
  lazyPlayer: (0, import_utils.lazy)(function () {
    return import(
    /* webpackChunkName: 'reactPlayerVidyard' */
    "./Vidyard");
  })
}, {
  key: "kaltura",
  name: "Kaltura",
  canPlay: import_patterns.canPlay.kaltura,
  lazyPlayer: (0, import_utils.lazy)(function () {
    return import(
    /* webpackChunkName: 'reactPlayerKaltura' */
    "./Kaltura");
  })
}, {
  key: "file",
  name: "FilePlayer",
  canPlay: import_patterns.canPlay.file,
  canEnablePIP: function canEnablePIP(url) {
    return import_patterns.canPlay.file(url) && (document.pictureInPictureEnabled || (0, import_utils.supportsWebKitPresentationMode)()) && !import_patterns.AUDIO_EXTENSIONS.test(url);
  },
  lazyPlayer: (0, import_utils.lazy)(function () {
    return import(
    /* webpackChunkName: 'reactPlayerFilePlayer' */
    "./FilePlayer");
  })
}];